<template>
  <div class="d-flex flex-column ga-6 border pa-6 rounded-sm">
    <BlockTitle title="СМИ о нас" />
    <div
      v-for="newItem in news"
      :key="newItem.id"
      class="d-flex ga-6"
    >
      <div class="news-item-info text-break">
        <img
          :src="newItem.publisher.logo.url"
          alt="/"
          width="200px"
          height="auto"
          class="mr-6 mb-4 rounded-sm"
        >
        <div class="text-body-2 text-secondary--text">
          {{ newItem.link }}
        </div>
      </div>

      <div>
        <AdminButton
          text="править"
          :link="reverseFull({ name: 'admin:info_news_change', args: [newItem.id] })"
        />
        <div class="text-subtitle-1 text--text mb-2">
          {{ newItem.header }}
        </div>
        <div class="text-body-2 text-secondary--text mb-4">
          {{ format(new Date(newItem.dt), 'dd MMMM Y', { locale: ru }) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          {{ newItem.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
import { ru } from 'date-fns/locale'
import { useContextStore, useURLStore } from 'src/store'
import BlockTitle from 'src/components/pages/info/pressa/components/BlockTitle.vue'
import AdminButton from 'src/components/common/AdminButton/AdminButton.vue'
import { News } from 'src/components/pages/info/pressa/types'

const { context } = useContextStore()
const { reverseFull, urls, patch } = useURLStore()

if (process.env.IS_SERVER && context.request.user.is_staff && context.flavour === 'full') {
  patch({ 'admin:info_news_change': urls['admin:info_news_change'] })
}

defineProps<{
  news: News[]
}>()
</script>

<style scoped lang="scss">
.news-item-info {
  width: 200px;
}
</style>
